<template>
  <div class="dashboard">
    <!-- <div class="vx-row">
      <div class="vx-col w-full mb-base">
        <vx-card
          slot="no-body"
          class="text-center bg-primary-gradient greet-user"
        >
          <img
            src="@/assets/images/elements/decore-left.png"
            class="decore-left"
            alt="Decore Left"
            width="200"
          />
          <img
            src="@/assets/images/elements/decore-right.png"
            class="decore-right"
            alt="Decore Right"
            width="175"
          />
          <feather-icon
            icon="AwardIcon"
            class="p-6 mb-8 bg-primary inline-flex rounded-full text-white shadow"
            svg-classes="h-8 w-8"
          ></feather-icon>
          <h1 class="mb-6 text-white">
            Tu suscripcion esta activa, {{ user.firstName }}
          </h1>
          <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-white">
            Tu suscripción se renovara
            <strong>de manera automatica</strong>, si tienes dudas, por favor
            ponte en contacto con nosotros.
          </p>
        </vx-card>
      </div> -->

    <!-- Facturas emitidas -->
    <!-- <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
        <StatisticsCardLine
          icon="FileTextIcon"
          statistic="1.2K"
          statistic-title="Facturas emitidas"
          :chart-data="analyticsData.subscribersGained"
          type="area"
        ></StatisticsCardLine>
      </div> -->
    <!-- </div> -->
    <HomeCard :invoices="invoices" :user="user"></HomeCard>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import StatisticsCardLine from "@/components/statistics-cards/StatisticsCardLine.vue";
import analyticsData from "./example.js";
import ChangeTimeDurationDropdown from "@/components/ChangeTimeDurationDropdown.vue";
import HomeCard from "@/components/homeCard.vue";
import { mapState } from "vuex";

export default {
  components: {
    VueApexCharts,
    StatisticsCardLine,
    ChangeTimeDurationDropdown,
    HomeCard
  },
  data() {
    return {
      analyticsData: analyticsData
    };
  },
  computed: {
    ...mapState(["user", "invoices"])
  }
};
</script>

<style lang="scss">
.dashboard {
  .greet-user {
    position: relative;
    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }
    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media (max-width: 576px) {
    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
}
</style>
